export default "__VITE_ASSET__D9Eqwo4e__"